<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
  ></loading>
    <b-card class="bCardGlobal">
      <b-row class="divSubtitulo m-1 mb-3">
        <b-col cols="6" md="10">
          <div>
            <p class="textoSubtitulo">Planeación diaria PTI</p>
          </div>
        </b-col>
        <b-col cols="6" md="2">
          <div>
            <p style="text-align: end" class="textoSubtitulo">Planea_diaria_ee_01</p>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="9" class="pt-3">
            <div class="d-flex">
                <p class="text-left" style="color: #0069A9; font-weight: 600;">Pacientes del día {{ obtenerFechaFormateada() }}</p>
                <em id="popover-calendario" v-b-tooltip.hover title="Cambiar fecha en el calendario" style="width: 20px; margin-top: -18px;" class="ml-3 calendar_outline"></em>
            </div>
            <b-popover target="popover-calendario" triggers="click blur" placement="bottom">
                <b-calendar style="width: 90%;" v-model="fechaInicio" class="mb-2" locale="es-MX" :valueAsDate="true" @input="traerPacientes"></b-calendar>
            </b-popover>
           <b-row class="mt-2">
            <b-col cols="5">
                <div class="barra-busqueda d-flex">
                    <b-form-input
                      class="input-filter"
                      size="md"
                      v-model="palabraClaveBusqueda"
                      placeholder="Búsqueda por id o nombre del paciente"
                      @input="buscarFiltros"
                    ></b-form-input>
                    <!-- @keydown.enter.native="buscarPlanes()" -->
            
                    <b-button size="sm" variant="info" class="mr-3">
                      <span 
                        ><em class="buscar_svg" style="height: 16px; margin-top: 8%; margin-bottom: -3px;"></em
                      ></span>
                     <!--  <span v-else><b-spinner small></b-spinner></span> -->
                    </b-button>
                    <!-- @click="buscarPlanes()" -->
                  </div>
            </b-col>
           </b-row>
           <br>
           <b-row style="background-color: #EBF9FF;">
            <b-col cols="3"></b-col>
            <b-col cols="8">
                <div class="d-flex justify-content-between mt-2">
                    <div>
                        <div class="d-flex">
                            <span v-if="filtros.presentador.length>0" :class="filtros.presentador.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" style="margin-right: 3px;"> &nbsp;({{filtros.presentador.length}})</span>
                            <a href="#" id="popover-filtro-presentador" :class="filtros.presentador.length>0 ? 'filtrosActivos' : 'filtrosInactivos'"  @click.prevent>Presentador <em class="arrow_down_svg icon-chevron"></em></a>
                        </div>
                        <b-popover target="popover-filtro-presentador" triggers="click blur" placement="bottom">
                            <b-form-checkbox-group stacked v-model="filtros.presentador"  style="width: 180px; overflow: auto; max-height: 200px">
                              <b-form-checkbox v-for="op in listaPresentadores" :key="op.nombrePresentador" :value="op.idPresentador" @input="buscarFiltros">
                                {{op.nombrePresentador}}
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-popover>
                    </div>
                    <div>
                        <div class="d-flex">
                            <span v-if="filtros.encargadoHerramientas.length>0" :class="filtros.encargadoHerramientas.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" style="margin-right: 3px;"> &nbsp;({{filtros.encargadoHerramientas.length}})</span>
                            <a href="#" id="popover-filtro-herramientas" :class="filtros.presentador.length>0 ? 'filtrosActivos' : 'filtrosInactivos'"  @click.prevent>Encargado herramientas <em class="arrow_down_svg icon-chevron"></em></a>
                        </div>
                        <b-popover target="popover-filtro-herramientas" triggers="click blur" placement="bottom">
                            <b-form-checkbox-group stacked v-model="filtros.encargadoHerramientas"  style="width: 180px; overflow: auto; max-height: 200px">
                              <b-form-checkbox v-for="op in listaPresentadoresHerramientas" :key="op.nombrePresentador" :value="op.idPresentador" @input="buscarFiltros">
                                {{op.nombrePresentador}}
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-popover>
                    </div>
                    <div>
                        <div class="d-flex" id="popover-filtro-contacto">
                            <span :class="filtros.contacto.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" style="margin-right: 3px;" v-if="filtros.contacto.length>0"> &nbsp;({{filtros.contacto.length}})</span>
                            <a href="#" :class="filtros.contacto.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" id="popover-filtro-presentador"  @click.prevent>Contacto <em class="arrow_down_svg icon-chevron"></em></a>
                        </div>
                        <b-popover target="popover-filtro-contacto" triggers="click blur" placement="bottom">
                            <b-form-checkbox-group stacked v-model="filtros.contacto"  style="width: 180px; overflow: auto; max-height: 200px">
                              <b-form-checkbox v-for="op in contacto" :key="op.nombreEstatus" :value="op.idEstatus" @input="buscarFiltros">
                                {{op.nombreEstatus}}
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </b-popover>
                    </div>
                    <div>
                        <div class="d-flex">
                            <span :class="filtros.motivoCita.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" style="margin-right: 3px;" v-if="filtros.motivoCita.length>0"> &nbsp;({{filtros.motivoCita.length}})</span>
                            <a href="#" :class="filtros.motivoCita.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" id="popover-filtro-motivo-cita"  @click.prevent>Motivo de cita <em class="arrow_down_svg icon-chevron"></em></a>
                        </div>
                        <div>
                            <b-popover target="popover-filtro-motivo-cita" triggers="click blur" placement="bottom">
                                <b-form-checkbox-group stacked v-model="filtros.motivoCita"  style="width: 180px; overflow: auto; max-height: 200px">
                                  <b-form-checkbox v-for="op in motivosCita" :key="op.nombreMotivo" :value="op.idMotivo" @input="buscarFiltros">
                                    {{op.nombreMotivo}}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-popover>
                        </div>
                    </div>
                    <div>
                        <div class="d-flex">
                            <span :class="filtros.motivoCita.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" style="margin-right: 3px;" v-if="filtros.estadoCita.length>0"> &nbsp;({{filtros.estadoCita.length}})</span>
                            <a href="#" :class="filtros.estadoCita.length>0 ? 'filtrosActivos' : 'filtrosInactivos'" id="popover-filtro-estado-cita"  @click.prevent>Estado de cita <em class="arrow_down_svg icon-chevron"></em></a>
                        </div>
                        <div>
                            <b-popover target="popover-filtro-estado-cita" triggers="click blur" placement="bottom">
                                <b-form-checkbox-group stacked v-model="filtros.estadoCita"  style="width: 180px; overflow: auto; max-height: 200px">
                                  <b-form-checkbox v-for="op in estadoCita" :key="op.nombreEstadoCita" :value="op.idEstadoCita" @input="buscarFiltros">
                                    {{op.nombreEstadoCita}}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </b-popover>
                        </div>
                    </div>
                    <div>
                        <b-button class="boton-inv" style="margin-left: 1%" variant="primary" v-if="filtrosActivos()" @click="limpiarFiltros()">
                            <em class="close_x_svg icon-boton"></em>
                        </b-button>
                    </div>
                </div>
            </b-col>
           </b-row>

           <div class="row mt-3 text-left" style="padding-left: 3%; font-size: .9em;">
            <div class="col-1"></div>
                <div class="col-3">
                    Paciente
                </div>
                <div class="col-3">
                    Información de la cita
                </div>
                <div class="col-1" style="padding: 0px;">
                    Hora de presentación
                </div>
                <div class="col-2">
                    Presentador
                </div>
                <div class="col-2">Contacto</div>     
           </div>
           
           <div class="scrollable-container no-horizontal-scroll pb-1 pr-1">
            <div class="mb-3" v-for="(paciente, index) in datosAMostrar" v-bind:key="index">
                <div :class="paciente.cardColapsada ? 'cardActiva' : 'cardInactiva'">
                    <div class="d-flex justify-content-between text-center " style="left: 0xp; top: 0px; height: 25px;" >
                        <div class="d-flex" v-b-tooltip.hover title="Ver ficha de cita del paciente" @click="mostrarDetalleCita(paciente)">
                            <div style="border-top-left-radius: 10px; width: 15px; border: 1px solid #c4c4c4;" :style="paciente.colorEstatusSDI"></div>
                            <div class="text-center" style="border-bottom-right-radius: 10px; width: auto; min-width: 80px;" :style="paciente.color"><p class="ml-1 mr-1" style="margin-top: 4%; font-size: 12px; color: rgb(29, 29, 29)">{{paciente.estatusCita}}</p></div>
                        </div>

                        <div class="mr-2">
                            <em v-if="paciente.observaciones.length > 0" v-b-tooltip.hover title="Esta cita tiene comentarios previos" class="ojo_svg" style="height: 20px; filter: brightness(0) saturate(100%) invert(81%) sepia(52%) saturate(1233%) hue-rotate(169deg) brightness(83%) contrast(90%);"></em>
                        </div>
                    </div>
                    <div class="row text-left" style="padding: 1% 0% 2% 3%;" v-b-toggle="'card' + index" @click="llenarTagMotivoCita(paciente.idPaciente,index)">
                        <div class="col-1">
                            <em class="patient_profile"></em>
                        </div>
                        <div class="col-3">
                            <p style="line-height: 1; margin-bottom: 5px; font-weight: 600; padding: 0px;">{{paciente.nombrePaciente}}</p>
                            <p style="line-height: 1; margin-bottom: 5px; font-size: 12px;">{{paciente.edad}}</p>
                            <p v-if="paciente.correo != null" style="line-height: 1; margin-bottom: 5px; font-size: 12px;">{{paciente.correo}}</p>
                            <p v-else style="line-height: 1; margin-bottom: 5px; font-size: 12px;">Sin correo electrónico</p>

                            <p v-if="paciente.celular != null" style="line-height: 1; margin-bottom: 5px; font-size: 12px;">{{paciente.celular | VMask("(###) - ### - ####") }}</p>
                            <p v-else style="line-height: 1; margin-bottom: 5px; font-size: 12px;">Sin número telefónico</p>
                        </div>
                        <div class="col-3">
                            <p style="line-height: 1; margin-bottom: 5px;">{{paciente.motivoCitaTag}}</p>
                            <p style="line-height: 1; margin-bottom: 5px; font-size: 12px;">{{paciente.nombreDoctor}}</p>
                            <p v-if="paciente.horaInicio != null && paciente.horaFin != null" style="line-height: 1; margin-bottom: 5px; font-size: 12px;">{{ formatoHorario(paciente.horaInicio, paciente.horaFin) }}</p>
                            
                        </div>
                        <div class="col-1" style="padding: 0px;">
                            <p v-if="paciente.planeacionPti.horaPresentacion != null" style="font-size: 14px;">{{ formatoHoraPresentacion(paciente.planeacionPti.horarioPresentacion) }}</p>
                        </div>

                        <div class="col-2" >
                            <p v-if="paciente.planeacionPti.presentador != null" style="font-size: 14px;">{{paciente.planeacionPti.presentador}}</p>
                        </div>
                        <div class="col-2">
                            <p v-if="paciente.planeacionPti.idEstatusContacto == 5" style="font-size: 14px; color: #AF470D;">Por contactar</p>
                            <p v-if="paciente.planeacionPti.idEstatusContacto != null && paciente.planeacionPti.idEstatusContacto == 4" style="font-size: 14px; color: #3EAD56;">{{paciente.planeacionPti.estatus}}</p>
                            <p v-if="paciente.planeacionPti.idEstatusContacto != null && paciente.planeacionPti.idEstatusContacto == 6" style="font-size: 14px; color: #D19248;">{{paciente.planeacionPti.estatus}}</p>
                        </div>
                    </div>
                  <div v-if="paciente.promocionesCita !== null && paciente.promocionesCita.length > 0" class="mr-2" style=" text-align: end; position: relative; top: 7px;left: 13px;">
                    <span v-if="paciente.promocionesCita.length === 1">
                           <em v-b-tooltip.right
                               :title="'CITA CON PROMO:'+paciente.promocionesCita[0].nombrePromocion" class="zoom pulsate-fwd fa fa-solid fa-tag" />
                    </span>
                    <span v-if="paciente.promocionesCita.length > 1">
                           <em v-b-tooltip.right
                           :title="'CITA CON PROMO: Múltiples promos'" class="zoom pulsate-fwd fa fa-solid fa-tag" />
                    </span>
                  </div>
                    <b-collapse :id="'card' + index" v-model="infoPacientes[index].cardColapsada" accordion="my-accordion" class="mx-auto" style="border-top: 1px solid rgb(220, 220, 220);">
                      <validation-observer ref="observer" v-slot="{ handleSubmit }">
                        <b-form @submit.stop.prevent="handleSubmit(() => guardarPlaneacion(paciente))">
                        <div class="row p-4">
                            <div class="col-3">
                                <b-form-group class="text-left">
                                    <label>¿Toma herramientas?</label>
                                    <b-form-checkbox class="text-left" switch v-model="paciente.planeacionPti.tomaHerramientas" :disabled="paciente.idEstatusCita == 12 || !$localStorageService.can('Daily_planner_editar')"></b-form-checkbox>
                                </b-form-group>
                            </div>
                            <div class="col-3">
                              <b-form-group class="text-left">
                                <label>Hora de presentación</label>
                                <validacion/>
                                <validation-provider v-slot="{ errors }" :rules="{ required: true }">
                                  <vue-timepicker
                                    id="idHoraInicio"
                                    v-model="paciente.planeacionPti.horaPresentacion"
                                    hide-disabled-items
                                    input-width="100%"
                                    format="HH:mm"
                                    :hour-range="horarioClinica"
                                    :minute-interval="15"
                                    hide-clear-button
                                    @change="handleTimeChange"
                                    :disabled="paciente.idEstatusCita == 12 || !$localStorageService.can('Daily_planner_editar')"
                                  ></vue-timepicker>
                                  <b-form-invalid-feedback :state="paciente.planeacionPti.horaPresentacion != null">
                                    Este campo es obligatorio
                                  </b-form-invalid-feedback>
                                </validation-provider>
                              </b-form-group>
                            </div>
                            <div class="col-6">
                                <b-form-group class="text-left">
                                    <label>Tag de la cita</label>
                                    <b-form-select
                                        :disabled="paciente.idEstatusCita == 12 || !$localStorageService.can('Daily_planner_editar')"
                                        :options="tagmotivocitaDatosArray"
                                        v-model="paciente.planeacionPti.idTagMotivoCita"
                                        text-field="descripcionTagMotivoCita"
                                        value-field="idTagMotivoCita">
                                    </b-form-select>
                                </b-form-group>
                            </div>
                            <div class="col-6">
                                <b-form-group class="text-left">
                                    <label>Encargado de presentación</label>
                                    <b-form-select
                                        :disabled="paciente.idEstatusCita == 12 || !$localStorageService.can('Daily_planner_editar')"
                                        :options="listaEncargados"
                                        v-model="paciente.planeacionPti.idEmpleado"
                                        placeholer="Encargado de la presentación"
                                        text-field="nombreEmpleado"
                                        value-field="idEmpleado"
                                        required>
                                    </b-form-select>
                                    <b-form-invalid-feedback :state="paciente.planeacionPti.idEmpleado != null && paciente.planeacionPti.idEmpleado != ''">
                                      Este campo es obligatorio
                                  </b-form-invalid-feedback>
                                </b-form-group>
                            </div>
                            <div class="col-6">
                                <b-form-group class="text-left">
                                  <label>Encargado de herramientas</label>
                                  <v-select
                                    :disabled="paciente.idEstatusCita == 12 || !$localStorageService.can('Daily_planner_editar')"
                                    style="text-transform: uppercase"
                                    placeholder="Encargado de herramientas"
                                    v-model="paciente.planeacionPti.idEmpleadoHerramientas"
                                    label="nombreEmpleado"
                                    :options="listaEncargadosHerramientas"
                                    :reduce="(val) => val.idEmpleado"
                                  ></v-select>
                                </b-form-group>
                            </div>
                            <div class="col-6">
                                <b-form-group class="text-left">
                                    <label>Contacto</label>
                                    <b-form-select
                                        :disabled="paciente.idEstatusCita == 12 || !$localStorageService.can('Daily_planner_editar')"
                                        :options="selectContacto"
                                        text-field="nombreContacto"
                                        value-field="idContacto"
                                        v-model="paciente.planeacionPti.idEstatusContacto">
                                    </b-form-select>
                                </b-form-group>
                            </div>
                        </div>
                       
                        <b-button v-if="paciente.idEstatusCita != 12 && $localStorageService.can('Daily_planner_editar')" class="mb-4" size="sm" variant="primary" type="submit" style="min-width: 100px;">Guardar</b-button>
                      </b-form>
                    </validation-observer>
                    </b-collapse>
              
            </div>
          
            </div>
                <div v-if="datosAMostrar.length === 0" class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
                    <p>No se encontraron resultados.</p>
                </div>
           </div>
           <!--  <div v-else class="mt-3">
                <p>Sin pacientes para mostrar</p>
            </div> -->
          
        </b-col>
        <b-col cols="3" class="mt-5" style="border-radius: 20px; max-height: 600px; border: 1px solid #9BD7E0;">
            <div v-if="pacienteSeleccionado == null" class="d-flex justify-content-center align-items-center" style="height: 600px;">
                <p  style="font-size: .8em;">Sin paciente seleccionado</p>
            </div>
            <div v-else style="max-height: 600px;">
                <div class="mt-3" style="border-bottom: 1px solid rgb(229, 229, 229);">
                    <em class="patient_profile"></em>
                    <p class="mt-1" style="top: 0px; left: 0px; font-weight: 600; font-size: .9em;">{{pacienteSeleccionado.nombrePaciente}}</p>
                </div>
                <div v-if="pacienteSeleccionado.observaciones.length > 0">
                    <div v-for="(comentario, index) in pacienteSeleccionado.observaciones" v-bind:key="index">
                        <div class="text-left mt-3">
                            <div class="d-flex">
                              <p class="mr-1" style="font-size: .7em; margin-bottom: 0px; color: #6E6E6E !important;">{{comentario.usuarioAlta}}</p>
                              <p style="font-size: .7em; margin-bottom: 0px; color: #6E6E6E !important;">{{comentario.fechaAlta | formatoFecha}}</p>
                            </div>
                            <div style="background-color: #F9F9F9; box-shadow: 0px 0px 1.5px 0px rgba(0, 0, 0, 0.32); min-height: 3em; padding: 2%; border-radius: 10px;">
                                <p style="font-size: .8em;">{{comentario.observacion}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="d-flex justify-content-center align-items-center" style="height: 350px;">
                    <p style="font-size: .8em;">Sin comentarios previos</p>
                </div>
                <div class="d-flex " style="bottom: 10px; position: absolute; width: 95%; margin-left: -5px;">
                    <b-form-input
                        placeholder="Escribe un nuevo comentario"
                        v-model="comentarioNuevo"
                        style="width: 96%;"
                    >
                    </b-form-input>
                    <b-button size="sm" variant="outline-info" @click="agregarObservacion()">
                        <span 
                          ><em class="send_comments" style="height: 16px; margin-top: 8%; margin-bottom: -3px;"></em
                        ></span>
                       <!--  <span v-else><b-spinner small></b-spinner></span> -->
                      </b-button>
                </div>
            </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
    size="xl"
    v-model="modalDetalleCita"
    hide-header
    hide-footer
    scrollable>
   
   <DetalleDeCita 
       :origen="4"
       :datosDetalle="datosDetalle"
       :datosDetalleOriginal="datosDetalleOriginal"
       :datosDetalleOverbooking="datosDetalleOverbooking"
       :filtros="filtrosModal"
       :pacienteSeleccionado="pacienteSeleccionado"
       :listaMotivosCancelacion="listaMotivosCancelacion"
       :fechaLlegada="fechaLlegada !== null ? true : null"
       :listaSINOFiltro="listaSINOFiltro"
       :datosBusqueda="datosBusqueda"
       @obtenerImagenPlan="obtenerImagenPlan"
       @buscarAgenda="buscarAgenda"
       @reagendarCita="reagendarCita"
       @activarModalEspera="activarModalEspera"
       @llenarDatosListaEspera="llenarDatosListaEspera"
       @sobreAgendar="sobreAgendar"
       ref="detalleDeCita"
   ></DetalleDeCita>
   
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { required } from "vuelidate/lib/validators";
import DetalleDeCita from "@/components/NuevaAgenda/DetalleDeCita";

export default {
  name: "PtiDailyPlanning",
  components: { Header, DetalleDeCita },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      datosBusqueda: {
            tratamientoID: 12,
            clinica: {
                clinicaID: null,
                nombre: "-",
            },
            clinicaNombre: "-",
            fechaInicio: undefined,
            fechaFin: undefined,
            fechaActual: new Date(),
            idEspecialidad: null,
            empleadoId: null,
        },
        modalDetalleCita: false,
        loading: false,
        horarioClinica:null,
        datosDetalle: [],
        planeacionPti: {
            contacto: null,
        },
        selectContacto: [
            {
                idContacto: 4,
                nombreContacto: "Contactado"
            },
            {
                idContacto: 5,
                nombreContacto: "Por contactar"
            },
            {
                idContacto: 6,
                nombreContacto: "Confirmado"
            }
        ],
        palabraClaveBusqueda: '',
        resultadosBusqueda: [],
        listaPresentadores: [],
        listaPresentadoresHerramientas: [],
        filtros: {
            presentador: [],
            encargadoHerramientas: [],
            contacto: [],
            motivoCita: [],
            estadoCita: [],
        },
        filtrosModal: {
      options: {
        motivosCita: [],
        estatusCita: [],
        especialidades: [],
        planes: [],
        tipos: [],
        doctores: [],
        sillones: []
      },
      selects: {
        porcentajeConfianza: [0, 100],
        montoPti: [0, 200000],
        motivosCita: [],
        estatusCita: [],
        especialidades: [],
        pacienteNatural: false,
        pacientePlan: false,
        todosPlanes: false,
        planes: [],
        tipos: [],
        nombreDoctor: "",
        doctores: [],
        sillones: []
      },
    },
        palabraClave: null,
        listaHerramientas: [
            { value: '1', text: 'Sí' },
            { value: '2', text: 'No' },
        ],
        comentarioNuevo: null,
        infoPacientes: [],
        listaTag: [
            { value: '1', text: 'Revisión y diagnóstico' },
            { value: '2', text: 'Limpieza' },
        ],
        listaEncargados: [
            { value: '1', text: 'OG María Fernanda Marquez Marin' },
        ],
        listaEncargadosHerramientas: [],
        listaEstatusContacto: [],
        idClinica: null,
        fechaInicio: null,
        fechaFin: null,
        motivosCita: [],
        hayResultados: true,
        contacto: [],
        estadoCita: [],
        tagmotivocitaDatosArray: [],
        fechaSeleccionada: null,
        eventos: [],
        citasSinProcesar: [],
        datosDetalleOriginal: null,
        pacienteSeleccionado: null,
        listaMotivosCancelacion: null,
        listaSINOFiltro: [],
        listaSINO: [
      {
        etiqueta: "SI",
        valor: true,
      },
      {
        etiqueta: "NO",
        valor: false,
      },
      
    ],
    datosDetalleOverbooking: null,
    fechaLlegada: null,
    horaPresentacionValida: false
    };
  },
  validations: {
        paciente:{
          planeacionPti:{
            horaPresentacion: {required}
          }
        }
      },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.listaSINOFiltro = this.listaSINO;
    this.idClinica = this.$localStorageService.getIdClinica();
    this.fechaInicio = this.$moment().startOf('day').add(1, 'day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    this.fechaFin = this.$moment().endOf('day').add(1, 'day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
/*     this.fechaInicio = this.$moment().startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    this.fechaFin = this.$moment().endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"); */
    this.llenarMotivosCancelacion();
    this.traerPacientes();
    this.obtenerEncargadosPresentacion();
    this.obtenerEncargadosHerramientas();
    this.obtenerHorariosClinica();

  },
  watch: {},
  methods: {
    handleTimeChange(){
     /*  if (this.pacienteSeleccionado.planeacionPti.horaPresentacion !== null && this.pacienteSeleccionado.planeacionPti.horaPresentacion !== undefined) {
        if (this.pacienteSeleccionado.planeacionPti.horaPresentacion.mm == null || this.pacienteSeleccionado.planeacionPti.horaPresentacion.mm == null || this.pacienteSeleccionado.planeacionPti.horaPresentacion.mm == "") {
          this.pacienteSeleccionado.planeacionPti.horaPresentacion.mm = "00";
        }
      } */
    },
    isHoraPresentacionValid(paciente) {
        return (
            paciente.planeacionPti.horaPresentacion != null &&
            paciente.planeacionPti.horaPresentacion.HH != '' &&
            paciente.planeacionPti.horaPresentacion.MM != ''
        );
    },

    async agregarObservacion(){
      await this.activarLoader();
      const datosParaGuardar = {
        idCita: this.pacienteSeleccionado.idCita,
        observaciones: this.comentarioNuevo
      };

      this.$http.post(this.$api + 'agenda/agregarObservacionCita', datosParaGuardar)
        .then(async () => {
            this.$swal.fire({
                icon: 'success',
                text: "Se guardó la observación correctamente",
                showConfirmButton: false,
                timer: 1500,
            });

            this.comentarioNuevo = "";
            this.traerPacientes();
            
        })
        .catch(async (error) => {
            console.error("Error al guardar la planeación:", error);
            this.$swal.fire({
                icon: 'error',
                text: "Ocurrió un error, por favor inténtelo más tarde",
                showConfirmButton: false,
                timer: 1500,
            });

            await this.desactivarLoader();
        });
    },

    async buscarAgenda(cerrarModal) {
        this.citasSinProcesar = Array();
        this.eventos = Array();
        this.eventosSobreAsig = Array();
        this.horariosDoctor = [];
        this.listaEspecialidades = [
          {
            id: null,
            nombre: "Todos",
            color: "white",
          },
        ];

        const idClinica = this.datosBusqueda.clinica.clinicaID;
        if (idClinica === undefined || idClinica === null || idClinica === 0) {
          return;
        }

        this.loading = true;

        const clinicaID = this.datosBusqueda.clinica.clinicaID;
        const fechaInicio =
            this.$moment(this.datosBusqueda.fechaInicio)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
        const fechaFin =
            this.$moment(this.datosBusqueda.fechaFin)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");


      const parametros = {
        idClinica: clinicaID,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin
      }
        this.$http
            .post(
                this.$api +
                "agenda/obtenerCitasClinica", parametros
            )
            .then((response) => {
              if (response.status === 200 && response.data.data !== undefined) {
                this.listaCitas = response;
                this.procesarBusquedaAgenda(response);
              }
            })
            .catch((error) => {
              console.error("No hay datos" + error);
              this.loading = false;
              this.loadingCAl = false;
              this.showDetail = cerrarModal === false ? true : false;
            }).finally(() => {
              this.loadingCAl = false;
              this.showDetail = cerrarModal === false ? true : false;
            });

    },
    calcularTamaniosColoresCitaMulti(datosCasilla) {
      let confirmados = 0;
      let asistidos = 0;
      let horaInicioCasilla = datosCasilla.citas[0].horaInicioCasilla;
      let horaFinCasilla = datosCasilla.citas[0].horaFinCasilla;
      datosCasilla.citas.forEach((it) => {
        if (it.horaInicioCasilla < horaInicioCasilla) {
          horaInicioCasilla = it.horaInicioCasilla;
        }

        if (it.horaFinCasilla > horaFinCasilla) {
          horaFinCasilla = it.horaFinCasilla;
        }

        if (Number(it.idEstatusCita) === 11) {
          confirmados++;
        } else if (Number(it.idEstatusCita) === 12) {
          asistidos++;
        }
      });

      const fc1 = new Date("2014-02-27T" + horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      datosCasilla.tamanioN = 26.75 * vecesRepetir;
      const tamanio = "height: " + datosCasilla.tamanioN + "px;";

      let color = "background:rgb(202, 225, 82);";
      if (confirmados === datosCasilla.citaSize) {
        color = "background: rgb(208, 38, 38);";
      } else if (asistidos === datosCasilla.citaSize) {
        color = "background: rgb(52, 141, 0);";
      } else if (confirmados > 0 && asistidos > 0) {
        color = "background: rgb(244, 142, 52);";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        datosCasilla.ancho = "width:20px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        datosCasilla.ancho = "width:" + 20 / num + "px;";
      } else {
        datosCasilla.ancho = "width:" + 80 / num + "px; color:black;";
      }

      datosCasilla.style = datosCasilla.ancho + color + tamanio;

      if (this.$debug) {
        datosCasilla.titleDebug =
            "  Color:" +
            color +
            "  Tamanio:" +
            tamanio +
            "  Ancho:" +
            datosCasilla.ancho;
      }

      return datosCasilla;
    },
    sobreAgendar(cita) {
      this.showDetail = true;
      this.datosDetalleOriginal = cita.citas;
      this.pacienteSeleccionado = this.datosDetalleOriginal[0];
      this.fechaLlegada = this.pacienteSeleccionado.fechaLlegada;

      this.datosDetalleOriginal.forEach((element) => {
        element.isCitaConfirmada =
            element.estatusCita == "CONFIRMADA" ? true : false;
        let color = element.color.replace(/background: rgb/g, "");
        let colorSombrero = element.colorEstatusSDI;
        let sinComa = color.replace(/;/g, "");
        element.colorCitaOverbooking =
            "border-color: " +
            " rgb" +
            sinComa +
            " rgb" +
            sinComa +
            " rgb" +
            sinComa +
            colorSombrero +
            ";border-width:3px 3px 3px 17px;width: 70%; height: 20%; margin:2%;box-shadow: 0px 4px 26px -11px rgba(0,0,0,0.59);border-radius: 10px;border-style: solid;";
      });
    },
    llenarDatosListaEspera(procesoManual, bandera) {
      if (procesoManual) {
        let indice = null;
        let especialidad = null;
        if(bandera !== 1) {
          indice = this.datosFormulario.idEspecialidad.indexOf(",");
          especialidad = indice !== -1 ? this.datosFormulario.idEspecialidad.substring(0, indice) : this.datosFormulario.idEspecialidad ;
        }else{
          especialidad = this.datosFormulario.idEspecialidad;
        }



        let datos = {
          idMotivoEspera: this.datosFormulario.idMotivoEspera,
          idPaciente: this.datosFormulario.idPaciente,
          comentario: this.datosFormulario.comentario,
          fechaFin: new Date(this.datosFormulario.fechaFin),
          fechaInicio: new Date(this.datosFormulario.fechaInicio),
          horafin: this.datosFormulario.horaFin.HH + this.datosFormulario.horaFin.mm,
          horaInicio: this.datosFormulario.horaInicio.HH + this.datosFormulario.horaInicio.mm,
          idEstatusListaEspera: 1,
          idClinica: this.$localStorageService.getIdClinica(),
          idEspecialidad: especialidad,
          idTratamiento: this.datosFormulario.idTratamiento,
          diasExclusion: this.datosFormulario.dias,
          procesoManual: procesoManual
        };

        let mostrarMensajeConfirmacion = bandera === 1 ? true : false;
        this.guardarListaEsperaDatos(datos, mostrarMensajeConfirmacion);

      }else {
       this.procesoListaEsperaAutomatica();
      }

    },

    async activarModalEspera(esPaciente) {
      this.hayPaciente = esPaciente != null && esPaciente ? esPaciente : false;

      if (this.hayPaciente){
        this.showDialogEnviaListEsperaDatos = true;
      }else{
        this.showDialogEnviaListEsperaCalendario = true
      }

      this.obtenerDias();
      this.overbookListaEspera = false;
      this.mostrarModalCrearCita(false);
      this.horarioDisponibleOverbooking = [];

      this.traerMotivoEspera();

      const today = this.$moment();
      const year = today.format("YYYY");

      var weeknumber = this.$moment(today, "MM-DD-YYYY").week();

      this.semanaActual = year + "-W" + weeknumber;
      this.rangoFecha = this.semanaActual;
      if (this.hayPaciente){
        this.pasarDatos()
      }

    },
    async reagendarCita(datosAgregar) {

      let tratamientosCita = null;
      this.loading = true;
      const parametros = {idCita: this.datosDetalle.idCita}
      await this.$http
          .post(
              this.$api +
              "agenda/obtenerTratamientosCita", parametros
          ).then((response) => {
            tratamientosCita = response.data.data;
      }).finally(()=> {
        this.loading = false;
      })

      if (tratamientosCita == null || tratamientosCita.length === 0) {
        tratamientosCita = datosAgregar.tratamientos;
      }

      this.datosPreCita = {
        idCita: datosAgregar.idCita,
        idPaciente: datosAgregar.idPaciente,
        sillon: datosAgregar.sillon,
        idEspecialidad: datosAgregar.idEspecialidad,
        idEmpleado: datosAgregar.idDoctor,
        fechaCita: datosAgregar.fechaCita,
        idTagMotivoCita: datosAgregar.idTagMotivoCita,
        horaInicio: {
          HH: datosAgregar.horaInicio.substring(0, 2),
          mm: datosAgregar.horaInicio.substring(3, 5)
        },
        tratamientos: tratamientosCita,
        comentario: datosAgregar.comentario,
        citaAdministrativa: datosAgregar.citaAdministrativa,

        citaReagendar: true,
        citaDesdeCal: false,
        citaEdicion: true,
        citaSobreAgendar: false
      };

      this.modalNuevaCita = true;
    },
    obtenerImagenPlan(idPlan) {
      const planImg = this.filtros.options.planes.find(it=>it.id===idPlan);

      if (planImg !== undefined && planImg !== null) {
        return planImg;
      }
      return null;
    },
    llenarMotivosCancelacion() {
      this.listaMotivosCancelacion = [];
      this.$http
          .get(this.$api + "catalogos/obtenerMotivosCancelacion")
          .then((response) => {
            if (response.status === 200) {
              this.listaMotivosCancelacion = response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    
    mostrarDetalleCita(cita){

        this.modalDetalleCita = true;
        this.pacienteSeleccionado = cita;
        this.datosDetalle = cita;
        this.comentarioNuevo = "";
        this.datosDetalleOverbooking = null;
        this.fechaLlegada = this.pacienteSeleccionado.fechaLlegada;
      
    },
    async procesarCitasClinica(response) {
        this.loading = true;
      if (
          response.data.data.citas !== undefined &&
          response.data.data.citas !== null
      ) {
        response.data.data.citas.forEach((v) => {
          v.horaInicio = v.horaInicio.toString();
          if (v.horaInicio.length < 4) {
            v.horaInicio = "0" + v.horaInicio;
          }

          v.horaFin = v.horaFin.toString();
          if (v.horaFin.length < 4) {
            v.horaFin = "0" + v.horaFin;
          }

          if (v.horaInicio.toString().length === 4) {
            v.horaInicioCasilla =
                v.horaInicio.substr(0, 2) + ":" + v.horaInicio.substr(2, 3);
          }
          if (v.horaFin.toString().length === 4) {
            v.horaFinCasilla =
                v.horaFin.substr(0, 2) + ":" + v.horaFin.substr(2, 3);
          }

          v.especialistaNino = false;
          if (
              v.idEspecialidadDoctor !== undefined &&
              v.idEspecialidadDoctor !== null
          ) {
            try {
              const especiDoc = v.idEspecialidadDoctor.split(",").map(Number);
              v.especialistaNino = especiDoc.indexOf(3) > -1;
            } catch (e) {
              console.error(e);
            }
          }

          const fechaEvento = this.$moment(v.fechaCitaSinZona).format(
              "YYYY/MM/DD"
          );
          v.fechaCita = this.$moment(v.fechaCitaSinZona);

          const sillon = v.sillon;

          v.titleDebug = "";
          if (this.$debug && v.idCita == 210000236) {
            v.titleDebug =
                "ID:" +
                v.idCita.idCita +
                " - estatus:" +
                v.idCita.idEstatusCita +
                v.idCita.notacionCanalOrigen +
                " " +
                (v.idCita.siglasAseguradora !== undefined &&
                v.idCita.siglasAseguradora !== null &&
                v.idCita.siglasAseguradora.length > 0
                    ? v.idCita.siglasAseguradora
                    : "") +
                " Pac: " +
                v.idCita.idPaciente +
                "-" +
                v.idCita.nombrePaciente +
                " Doc: " +
                v.idCita.idDoctor +
                "-" +
                v.idCita.nombreDoctor +
                " Sillón: " +
                v.idCita.sillon +
                " Fecha: " +
                this.$formatoFecha(v.idCita.fechaCita) +
                " Horario: " +
                this.$formatoHoraDeHora(v.idCita.horaInicioCasilla) +
                " a " +
                this.$formatoHoraDeHora(v.idCita.horaFinCasilla);
          }

          v.inicialesDoctor = this.$iniciales(v.nombreDoctor);
          
          v.mostrarSiglasAseguradora =
              v.siglasAseguradora !== undefined &&
              v.siglasAseguradora !== null &&
              v.siglasAseguradora.length > 0;

          if (v.motivoCitaTag !== undefined) {
            v.citaUrgencia = v.motivoCitaTag === "DOLOR/URGENCIA";
          }

          if (!this.semanalDiaria){
            v = this.calcularTamaniosColoresCita(v);
          }else{
            v = this.calcularTamaniosColoresCitaDiarias(v);
          }
          

          this.citasSinProcesar.push(v);
          

          let citaParaCasilla = JSON.parse(JSON.stringify(v));

          ////////encontrar cita en eventos procesados
          const pos = fechaEvento + "-" + v.horaInicio + "-" + sillon;
          let datosCasilla = this.eventos[pos];

          if (datosCasilla === undefined || datosCasilla == null) {
            let eventoEncontrado = undefined;
            for (let [key, ev] of Object.entries(this.eventos)) {
              console.info(key);
              eventoEncontrado = ev.citas.find(evv => {
                return evv.fechaCitaSinZona == v.fechaCitaSinZona
                && Number(evv.horaInicio) < Number(v.horaFin)
                && Number(evv.horaFin) > Number(v.horaInicio)
                && evv.sillon == v.sillon
              });

              if (eventoEncontrado != undefined) {
                datosCasilla = ev;
                break;
              }
            }
          }

          ////////

          if (datosCasilla === undefined || datosCasilla === null) {
            datosCasilla = {
              style: citaParaCasilla.style,
              ancho: citaParaCasilla.ancho,
              tamanioN: citaParaCasilla.tamanioN,
              titleDebug: citaParaCasilla.titleDebug,
              colorEstatusSDI: citaParaCasilla.colorEstatusSDI,
              citaUrgencia: citaParaCasilla.citaUrgencia,
              notacionCanalOrigen: citaParaCasilla.notacionCanalOrigen,
              inicialesDoctor: citaParaCasilla.inicialesDoctor,
              lstImagenes: citaParaCasilla.lstImagenes,
              mostrarSiglasAseguradora:
              citaParaCasilla.mostrarSiglasAseguradora,
              siglasAseguradora: citaParaCasilla.siglasAseguradora,
              citas: [citaParaCasilla],
              citaSize: null,
            };

            this.eventos[pos] = datosCasilla;
          } else {
            datosCasilla.colorEstatusSDI = undefined; //quitamos el color del copete cuando hay mas citas
            datosCasilla.notacionCanalOrigen +=
                "/" + citaParaCasilla.notacionCanalOrigen;
            datosCasilla.inicialesDoctor +=
                "/" + citaParaCasilla.inicialesDoctor;
            datosCasilla.siglasAseguradora +=
                "/" + citaParaCasilla.siglasAseguradora;

            if (datosCasilla.lstImagenes === null) {
              datosCasilla.lstImagenes = [];
            }
            datosCasilla.lstImagenes = datosCasilla.lstImagenes.concat(
                citaParaCasilla.lstImagenes
            );
            datosCasilla.lstImagenes = datosCasilla.lstImagenes.filter(
                (valor, indice) => {
                  return datosCasilla.lstImagenes.indexOf(valor) === indice;
                }
            );

            datosCasilla.citaUrgencia =
                datosCasilla.citaUrgencia ||
                (!datosCasilla.citaUrgencia && citaParaCasilla.citaUrgencia);

            datosCasilla.mostrarSiglasAseguradora =
                datosCasilla.mostrarSiglasAseguradora ||
                (!datosCasilla.mostrarSiglasAseguradora &&
                    citaParaCasilla.mostrarSiglasAseguradora);

            datosCasilla.citas.push(citaParaCasilla);

            datosCasilla.citaSize = datosCasilla.citas.length;
            if (!this.semanalDiaria){
              datosCasilla = this.calcularTamaniosColoresCitaMulti(datosCasilla);
            }else{
              datosCasilla = this.calcularTamaniosColoresCitaMultiDiarias(datosCasilla);
            }

          }


        });
        this.loading = false;
        return this.eventos;
      }
      this.loading = false;
      return true;
    },

    calcularTamaniosColoresCita(cita) {
      cita.color = "background: rgb(255, 102, 0);";
      this.colorCita = "(255, 102, 0)";
      cita.tamanio = "height: 26.75px;";
      cita.tamanioN = 26.75;

      const fc1 = new Date("2014-02-27T" + cita.horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + cita.horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      const tamanio = 26.75 * vecesRepetir;
      cita.tamanioN = tamanio;

      cita.tamanio = "height: " + tamanio + "px;";

      if (Number(cita.idEstatusCita) === 11) {
        cita.color = "background: rgb(208, 38, 38);";
        this.colorCita = "(208, 38, 38)";
      } else if (Number(cita.idEstatusCita) === 12) {
        cita.color = "background: rgb(52, 141, 0);";
        this.colorCita = "(208, 38, 38)";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        cita.ancho = "width:20px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        cita.ancho = "width:" + 20 / num + "px;";
      } else {
        cita.ancho = "width:" + 80 / num + "px; color:black;";
      }

      cita.style = cita.ancho + cita.color + cita.tamanio;

      if (this.$debug) {
        cita.titleDebug =
            cita.titleDebug +
            "  Color:" +
            cita.color +
            "  Tamanio:" +
            cita.tamanio +
            "  Ancho:" +
            cita.ancho;
      }

      return cita;
    },

    calcularTamaniosColoresCitaDiarias(cita) {
      cita.color = "background: rgb(255, 102, 0);";
      this.colorCita = "(255, 102, 0)";
      cita.tamanio = "height: 26.75px;";
      cita.tamanioN = 26.75;

      const fc1 = new Date("2014-02-27T" + cita.horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + cita.horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      const tamanio = 26.75 * vecesRepetir;
      cita.tamanioN = tamanio;

      cita.tamanio = "height: " + tamanio + "px;";

      if (Number(cita.idEstatusCita) === 11) {
        cita.color = "background: rgb(208, 38, 38);";
        this.colorCita = "(208, 38, 38)";
      } else if (Number(cita.idEstatusCita) === 12) {
        cita.color = "background: rgb(52, 141, 0);";
        this.colorCita = "(208, 38, 38)";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {

        cita.ancho = "width:160px; margin-left: 16px;";
      } else if (this.getNumeroSillonesClinica <= 6) {

        cita.ancho = "width:" + 130 / num + "px; margin-left: 10px;";}
      else {

        cita.ancho = "width:" + 500 / num + "px; color:black; margin-left: 6px;";
      }

      cita.style = cita.ancho + cita.color + cita.tamanio;

      if (this.$debug) {
        cita.titleDebug =
            cita.titleDebug +
            "  Color:" +
            cita.color +
            "  Tamanio:" +
            cita.tamanio +
            "  Ancho:" +
            cita.ancho;
      }

      return cita;
    },

    calcularTamaniosColoresCitaMultiDiarias(datosCasilla) {
      let confirmados = 0;
      let asistidos = 0;
      let horaInicioCasilla = datosCasilla.citas[0].horaInicioCasilla;
      let horaFinCasilla = datosCasilla.citas[0].horaFinCasilla;
      datosCasilla.citas.forEach((it) => {
        if (it.horaInicioCasilla < horaInicioCasilla) {
          horaInicioCasilla = it.horaInicioCasilla;
        }

        if (it.horaFinCasilla > horaFinCasilla) {
          horaFinCasilla = it.horaFinCasilla;
        }

        if (Number(it.idEstatusCita) === 11) {
          confirmados++;
        } else if (Number(it.idEstatusCita) === 12) {
          asistidos++;
        }
      });

      const fc1 = new Date("2014-02-27T" + horaInicioCasilla);
      const fc2 = new Date("2014-02-27T" + horaFinCasilla);
      const difMilisegundos = Math.abs(fc2 - fc1);
      const difMinutos = Math.floor(difMilisegundos / 1000 / 60);
      let vecesRepetir = Math.abs(difMinutos / 15);

      if (vecesRepetir === 0) {
        vecesRepetir++;
      }

      datosCasilla.tamanioN = 26.75 * vecesRepetir;
      const tamanio = "height: " + datosCasilla.tamanioN + "px;";

      let color = "background:rgb(202, 225, 82);";
      if (confirmados === datosCasilla.citaSize) {
        color = "background: rgb(208, 38, 38);";
      } else if (asistidos === datosCasilla.citaSize) {
        color = "background: rgb(52, 141, 0);";
      } else if (confirmados > 0 && asistidos > 0) {
        color = "background: rgb(244, 142, 52);";
      }

      const num = this.getNumeroSillonesClinica - 4;
      if (this.getNumeroSillonesClinica <= 4) {
        datosCasilla.ancho = "width:160px; margin-left: 16px;";
      } else if (this.getNumeroSillonesClinica <= 6) {
        datosCasilla.ancho = "width:" + 400 / num + "px; margin-left: 10px;";}
      else {
        datosCasilla.ancho = "width:" + 500 / num + "px; color:black; margin-left: 6px;";
      }

      datosCasilla.style = datosCasilla.ancho + color + tamanio;

      if (this.$debug) {
        datosCasilla.titleDebug =
            "  Color:" +
            color +
            "  Tamanio:" +
            tamanio +
            "  Ancho:" +
            datosCasilla.ancho;
      }

      return datosCasilla;
    },

    obtenerFechaFormateada() {
        const fechaFormateada = this.$moment.utc(this.fechaInicio).format("DD [de] MMMM [del] YYYY");
        return fechaFormateada;
    },

    activarLoader() {
      this.loading = true;
    },
    desactivarLoader() {
      this.loading = false;
    },

    guardarPlaneacion(paciente){
        this.activarLoader();
        const fechaInicioMoment = this.$moment(this.fechaInicio, "YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        const fechaInicioDate = fechaInicioMoment.toDate();
       /*  paciente.planeacionPti.horaPresentacion = parseInt(paciente.planeacionPti.horaPresentacion.HH + paciente.planeacionPti.horaPresentacion.mm);
        const fechaInicioMoment = this.$moment(this.fechaInicio, "YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        const fechaInicioDate = fechaInicioMoment.toDate();
        paciente.planeacionPti.fechaPresentacion = fechaInicioDate; */
        const datosParaGuardar = {
            idPlaneacionPTI: paciente.planeacionPti.idPlaneacionPTI,
            idCita: paciente.planeacionPti.idCita,
            idEstatusContacto: paciente.planeacionPti.idEstatusContacto,
            estatus: paciente.planeacionPti.estatus,
            idEmpleado: paciente.planeacionPti.idEmpleado,
            idEmpleadoHerramientas: paciente.planeacionPti.idEmpleadoHerramientas,
            presentador: paciente.planeacionPti.presentador,
            idTagMotivoCita: paciente.planeacionPti.idTagMotivoCita,
            motivoCita: paciente.planeacionPti.motivoCita,
            horaPresentacion: parseInt(paciente.planeacionPti.horaPresentacion.HH + paciente.planeacionPti.horaPresentacion.mm),
            fechaPresentacion: fechaInicioDate,
            tomaHerramientas: paciente.planeacionPti.tomaHerramientas,
            horarioPresentacion: parseInt(paciente.planeacionPti.horaPresentacion.HH + paciente.planeacionPti.horaPresentacion.mm)
        };
        
        this.$http.post(this.$api + 'planeacion/guardar', datosParaGuardar)
        .then(async () => {
            this.$swal.fire({
                icon: 'success',
                text: "Se guardó la planeación correctamente",
                showConfirmButton: false,
                timer: 1500,
            });

            // Después de la alerta, realiza la carga de pacientes
             this.traerPacientes();
            
        })
        .catch(async (error) => {
            console.error("Error al guardar la planeación:", error);
            this.$swal.fire({
                icon: 'error',
                text: "Ocurrió un error, por favor inténtelo más tarde",
                showConfirmButton: false,
                timer: 1500,
            });

            await this.desactivarLoader();
        });
    },

    obtenerHorariosClinica(){
      const parametros = {
        idClinica: this.idClinica,
        fechaInicio: this.fechaInicio
      }
        this.$http.post(this.$api + "agenda/obtenerHorariosClinicaParaAgenda", parametros).then((response) => {
            this.procesarDatosHorariosClinica(response);
          }).catch((error) => {
            console.error("Error al obtener horarios de la clínica:", error);
          });
    },

    procesarDatosHorariosClinica(response) {
        const data = response.data.data;
        this.horaInicioMenor = this.encontrarHoraInicioMenor(data);
        this.horaFinMayor = this.encontrarHoraFinMayor(data);
        this.horarioClinica = this.convertirARangoHorario(this.horaInicioMenor, this.horaFinMayor);
    },

    convertirAHoraFormato(hora) {
        const horas = Math.floor(hora / 100);
        const amPm = horas >= 12 ? 'p' : 'a';
        const horasFormato12 = horas > 12 ? horas - 12 : horas;
        return `${horasFormato12}${amPm}`;
    },

    convertirARangoHorario(horaInicio, horaFin) {
        const horaInicioFormato = this.convertirAHoraFormato(horaInicio);
        const horaFinFormato = this.convertirAHoraFormato(horaFin);
        return [[horaInicioFormato, horaFinFormato]];
    },

    encontrarHoraInicioMenor(data) {
        const dataOrdenada = data.slice().sort((a, b) => a.horaInicio - b.horaInicio);
        return dataOrdenada[0].horaInicio;
    },
    encontrarHoraFinMayor(data) {
        const dataOrdenada = data.slice().sort((a, b) => b.horaFin - a.horaFin);
        return dataOrdenada[0].horaFin;
    },

    obtenerEncargadosPresentacion(){
        const param = {
          idClinica: this.idClinica
        }
        this.$http.post(this.$api + "diagnostico/hoja/obtenerCoordinadoresEEOGS", param).then((response) => {
            this.listaEncargados = response.data.data;
        }).catch((error) => {
            console.error("Error al obtener los presentadores de la clínica:", error);
        });
    },

    obtenerEncargadosHerramientas(){
        const param = {
          idClinica: this.idClinica
        }
        this.$http.post(this.$api + "diagnostico/hoja/obtenerEmpleadosClinica", param).then((response) => {
            this.listaEncargadosHerramientas = response.data.data;
        }).catch((error) => {
            console.error("Error al obtener los presentadores de la clínica:", error);
        });
    },

    llenarTagMotivoCita(idPaciente,index){
        this.infoPacientes.forEach((paciente, i) => {
            if (i !== index) {
                paciente.cardColapsada = false;
            }
        });

        this.pacienteSeleccionado = !this.infoPacientes[index].cardColapsada ? this.infoPacientes[index] : null;
        const param = {
          idPaciente: idPaciente
        }
        this.$http.post(this.$api + "tagmotivocita/tagmotivocita/paciente", param).then((response) => {
            this.tagmotivocitaDatosArray = response.data.data;
        }).catch((error) => {
            console.error("Error al obtener tag de cita por paciente:", error);
        });
    },

    limpiarFiltros(){
        this.filtros = {
            presentador: [],
            encargadoHerramientas: [],
            contacto: [],
            motivoCita: [],
            estadoCita: [],
        };
        this.buscarFiltros();
    },

    filtrosActivos() {
        return (
            this.filtros.presentador.length > 0 ||
            this.filtros.encargadoHerramientas.length > 0 ||
            this.filtros.motivoCita.length > 0 ||
            this.filtros.contacto.length > 0 ||
            this.filtros.estadoCita.length > 0
        );
    },

    actualizarResultados() {
        this.hayResultados = this.resultadosBusqueda.length > 0 || this.filtrosActivos();
    },

    buscarFiltros(){
        let resultadosFiltrados = this.infoPacientes.filter(paciente => {
            // Filtro Presentador
            const filtroPresentador = this.filtros.presentador.length === 0 || this.filtros.presentador.includes(paciente.planeacionPti.idEmpleado);
            // Filtro Encargado de herramientas
            const filtroHerramientas = this.filtros.presentador.length === 0 || this.filtros.presentador.includes(paciente.planeacionPti.idEmpleadoHerramientas);
            // Filtro Motivo de Cita
            const filtroMotivoCita = this.filtros.motivoCita.length === 0 || this.filtros.motivoCita.includes(paciente.idTagMotivoCita);
            // Filtro contacto
            const filtroContacto = this.filtros.contacto.length === 0 || this.filtros.contacto.includes(paciente.planeacionPti.idEstatusContacto);
            // Filtro Estado de cita
            const filtroEstadoCita = this.filtros.estadoCita.length === 0 || this.filtros.estadoCita.includes(paciente.idEstatusCita);

            return filtroPresentador && filtroHerramientas && filtroMotivoCita && filtroContacto && filtroEstadoCita;
        });


        // Aplica el filtro de palabra clave
        this.resultadosBusqueda = resultadosFiltrados.filter(paciente => paciente.nombrePaciente.toLowerCase().includes(this.palabraClaveBusqueda.toLowerCase()) || paciente.idPaciente.toString().includes(this.palabraClaveBusqueda));
        
        this.pacienteSeleccionado = null;
        this.infoPacientes.forEach(element => {
          element.cardColapsada = false;
        });
    },

    llenarFiltros(){
        this.loading = true;
        var idsVistos = new Set();
        this.listaPresentadores = this.infoPacientes.reduce((resultado, paciente) => {
      
        if (paciente.planeacionPti.idEmpleado != null && !idsVistos.has(paciente.planeacionPti.idEmpleado)) {
          
            idsVistos.add(paciente.planeacionPti.idEmpleado);     
            
            resultado.push({ idPresentador: paciente.planeacionPti.idEmpleado, nombrePresentador: paciente.planeacionPti.presentador });
        }
        return resultado;
        }, []);

        this.listaPresentadoresHerramientas = this.infoPacientes.reduce((resultado, paciente) => {
        if (paciente.planeacionPti.idEmpleadoHerramientas != null && !idsVistos.has(paciente.planeacionPti.idEmpleadoHerramientas)) {
          
          idsVistos.add(paciente.planeacionPti.idEmpleadoHerramientas);     
          
          resultado.push({ idPresentador: paciente.planeacionPti.idEmpleadoHerramientas, nombrePresentador: paciente.planeacionPti.nombreHerramientas });
        }
        return resultado;
        }, []);

        idsVistos = new Set();
        this.contacto = this.infoPacientes.reduce((resultado, paciente) => {
         if (!idsVistos.has(paciente.planeacionPti.idEstatusContacto)) {
                idsVistos.add(paciente.planeacionPti.idEstatusContacto);            
                resultado.push({ idEstatus: paciente.planeacionPti.idEstatusContacto, nombreEstatus: paciente.planeacionPti.idEstatusContacto == 5 ? "Por contactar" :  paciente.planeacionPti.estatus });
            }
        return resultado;
        }, []);

        idsVistos = new Set();
        this.motivosCita = this.infoPacientes.reduce((resultado, paciente) => {
        if (!idsVistos.has(paciente.idTagMotivoCita)) {
            idsVistos.add(paciente.idTagMotivoCita);            
            resultado.push({ idMotivo: paciente.idTagMotivoCita, nombreMotivo: paciente.motivoCitaTag });
        }
        return resultado;
        }, []);

        idsVistos = new Set();
        this.estadoCita = this.infoPacientes.reduce((resultado, paciente) => {
        if (!idsVistos.has(paciente.idEstatusCita)) {
            idsVistos.add(paciente.idEstatusCita);            
            resultado.push({ idEstadoCita: paciente.idEstatusCita, nombreEstadoCita: paciente.estatusCita });
        }
        return resultado;
        }, []);  
        this.loading = false;
    },
  
    traerPacientes(){
        this.loading = true;
        const clinicaID = this.idClinica;
        var fechaInicio = this.fechaInicio;
        var fechaFin = this.fechaFin;
        if(typeof this.fechaInicio == "object"){
          fechaInicio = this.$moment(this.fechaInicio).startOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
          fechaFin = this.$moment(this.fechaInicio).endOf('day').format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
        }

        const parametros = {
        idClinica: clinicaID,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin
      }
        this.$http.post(this.$api + "agenda/obtenerCitasClinicaDailyPlanner", parametros).then(async(respuesta) => {
            if (respuesta.data.data) {
                this.infoPacientes = [];
                this.infoPacientes = respuesta.data.data.citas;
                this.infoPacientes.forEach(paciente => {
                    paciente.planeacionPti.horarioPresentacion = paciente.planeacionPti.horaPresentacion != null ? paciente.planeacionPti.horaPresentacion : null;
                    paciente.planeacionPti.horaPresentacion = paciente.planeacionPti.horaPresentacion != null ? this.formatoSelectHoraPresentacion(paciente.planeacionPti.horaPresentacion) : null;
                    paciente.colorEstatusSDI = "background-color:" + paciente.colorEstatusSDI;
                });
             
                this.llenarFiltros();
                await this.procesarCitasClinica(respuesta);
                this.pacienteSeleccionado = null;
                this.loading = false;
                
            }
        }).catch((error) => {
            console.error("Error al obtener citas de la clínica:", error);
            this.loading = false;
        });
    },
  },

  computed: {
    datosAMostrar() {
        this.actualizarResultados();
        return this.hayResultados ? this.resultadosBusqueda : this.infoPacientes;
    },

    formatoHorario() {
        return function (horaInicio, horaFin) {
            horaInicio = horaInicio.toString();
            horaFin = horaFin.toString();
            return `${horaInicio.substr(0, 2)}:${horaInicio.substr(2, 3)} - ${horaFin.substr(0, 2)}:${horaFin.substr(2, 3)}`;
        };
    },

    formatoHoraPresentacion() {
        return function (horaInicio) {
            if(horaInicio == null){
                return;
            }
            horaInicio = horaInicio.toString();
            if(horaInicio.length > 3){
              return `${horaInicio.substr(0, 2)}:${horaInicio.substr(2, 3)}`;
            }else{
              return `0${horaInicio.substr(0, 1)}:${horaInicio.substr(1, 3)}`;
            }
            
        };
    },

    formatoSelectHoraPresentacion() {
    return function (horaPresentacion) {
        horaPresentacion = horaPresentacion.toString();
        var horas = null;
        var minutos = null;
        if(horaPresentacion.length > 3){
          horas = horaPresentacion.substring(0, 2);
          minutos = horaPresentacion.substring(2, 4);
        }else{
          horas = "0" + horaPresentacion.substring(0, 1);
          minutos = horaPresentacion.substring(1, 3);
        }
        

        const horario = {
                HH: horas,
                mm: minutos
            };

        return horario;
    };
}

  },
};
</script>

<style scoped>
    p{
        color: #6F6F6F;
    }

    .btn-primary {
        color: #FFF;
        background-color: #3F9BD3;
    }

    .btn-primary:hover {
        color: #3F9BD3;
        background-color: #FFF;
    }


    .icon-boton {
        margin: auto;
        height: 10px;
        display: block;
        padding: 1px;
    }

    .boton-inv, .boton-inv:hover {
        margin-top: -10px;
        border-radius: 50rem;
        color:  var(--color-icono);
        background-color: white;
        border-color: white;
        filter: drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.16));
        padding: 5px;
    }

    .boton-inv:hover, .boton-inv:active {
        border-color: var(--color-icono);
    }

    .filtrosActivos{
        font-weight: 600;
        color: #0069A9 !important;
        font-size: .8em;
    }

    .filtrosInactivos{
        color: #6F6F6F !important;
        font-size: .8em;
    }

    .cardActiva{
        border: 1px #6AB1BC solid;
        background-color: #FBFCFF;
        border-radius: 20px;
    }

    .cardInactiva{
        border: 1px solid #E6E6E6;
        border-radius: 20px;
    }

    .icon-chevron {
        margin-top: 3px;
        height: 10px;
        display: inline;
        padding: 1px;
    }

    .filtros, .filtros:hover {
        background: none;
        border: none;
        color: var(--color-icono);
        font-size: 10px;
        font-weight: bolder;
    }

    .filtros:hover {
        border-bottom: solid 2px var(--color-icono);
    }
    .barra-busqueda {
        border-width: 1px;
        border-style: solid;
        border-color: #c2e7ff;
        background: #ffffff;
        padding-top: 2px;
        padding-bottom: 2px;
        border-radius: 20px;
        text-align: left;
        align-items: center;
        
        min-width: 100px !important;
    }
    .zoom {
      font-size: x-large;
      transition: transform .2s; /* Animation */
      margin: 0 auto;
      color: red;
    }
    .zoom:hover {
      color: gray;
      transform: scale(1.5);
    }
</style>
